<template>
  <section class="documentation">
    <div class="custom-container">
      <h1 class="documentation__title ">
        Documentation
      </h1>


      <div class="docs_ui d-flex  flex-d-column ">
        <h2 class="docs_ui__title">Docs UI</h2>
        <div class="docs_ui__radio_buttons d-inline-flex  align-items-center">

          <div class="radio_buttons_wrapper">
            <input type="radio" id="swagger" class="custom_radio_button" value="swagger" v-model="api_documentation_ui_style"/>
            <label for="swagger">Swagger</label>
          </div>
          <div class="radio_buttons_wrapper">
            <input type="radio" id="rapidoc" class="custom_radio_button" value="rapidoc" v-model="api_documentation_ui_style"/>
            <label for="rapidoc">Rapidoc</label>
          </div>
          <div class="radio_buttons_wrapper">
            <input type="radio" id="redoc" class="custom_radio_button" value="redoc" v-model="api_documentation_ui_style"/>
            <label for="redoc">Redoc</label>
          </div>
          <div class="radio_buttons_wrapper">
            <input type="radio" id="openapi" class="custom_radio_button" value="openapi" v-model="api_documentation_ui_style"/>
            <label for="openapi">OpenAPI</label>
          </div>
        </div>
      </div>

      <div class="api_docs d-flex  flex-d-column ">
        <h2 class="api_docs__title">API Docs</h2>
        <div class="api_docs__buttons d-inline-flex align-items-center">

        <template v-if="api_documentation_ui_style == 'swagger'">
          <a href="https://frc.aviapages.com/api/documentation/" target="_blank" class="btn">Flight Calculator</a>
          <a href="https://dir.aviapages.com/api/documentation/#/aircraft" target="_blank" class="btn">Charter Directories</a>
          <a href="https://dir.aviapages.com/api/documentation/#/charter_quotes" target="_blank" class="btn">Charter Quote</a>
          <a href="https://dir.aviapages.com/api/documentation/#/metars" target="_blank" class="btn">Weather and NOTAM</a>
        </template>
        <template v-else-if="api_documentation_ui_style == 'rapidoc'">
            <a href="https://frc.aviapages.com/api/documentation/rapidoc/#post-/flight_calculator/" target="_blank" class="btn">Flight Calculator</a>
            <a href="https://dir.aviapages.com/api/documentation/rapidoc/#get-/api/aircraft/" target="_blank" class="btn">Charter Directories</a>
            <a href="https://dir.aviapages.com/api/documentation/rapidoc/#get-/api/charter_quotes/" target="_blank" class="btn">Charter Quote</a>
            <a href="https://dir.aviapages.com/api/documentation/rapidoc/#get-/api/metars/" target="_blank" class="btn">Weather and NOTAM</a>
        </template>
          <template v-else-if="api_documentation_ui_style == 'redoc'">
            <a href="https://frc.aviapages.com/api/documentation/redoc/#tag/flight_calculator" target="_blank" class="btn">Flight Calculator</a>
            <a href="https://dir.aviapages.com/api/documentation/redoc/#tag/aircraft" target="_blank" class="btn">Charter Directories</a>
            <a href="https://dir.aviapages.com/api/documentation/redoc/#tag/charter_quotes" target="_blank" class="btn">Charter Quote</a>
            <a href="https://dir.aviapages.com/api/documentation/redoc/#tag/metars" target="_blank" class="btn">Weather and NOTAM</a>
        </template>
          <template v-else-if="api_documentation_ui_style == 'openapi'">
            <a href="https://frc.aviapages.com/api/schema/" class="btn">Flight Calculator</a>
            <a href="https://dir.aviapages.com/api/schema/" class="btn">Charter Directories</a>
            <a href="https://dir.aviapages.com/api/schema/" class="btn">Charter Quote</a>
            <a href="https://dir.aviapages.com/api/schema/" class="btn">Weather and NOTAM</a>
        </template>

<!--          <a href="" class="btn">Schedule and Empty Legs</a>-->

        </div>
      </div>


    </div>
  </section>





</template>

<script>
export default {
  name: "DocumentationView",
  data(){
    return {
      api_documentation_ui_style:'swagger',

  }
}
}
</script>

<style scoped lang="scss">

.documentation{
  padding-top: 8.125rem;
  padding-bottom: 10.8125rem;
  @include media-breakpoint-down(md){
    padding: 3.75rem 0 5.625rem 0;
  }

  &__title{
    font-size: $h1-font-size;
    font-weight: 600;
    text-align: center;
    margin-bottom: 3.125rem;
    @include media-breakpoint-down(md){
      margin-bottom: 3.75rem;
    }
  }

}
.docs_ui{
  flex-direction: column;
  align-items: center;
  &__title{
    font-size: $h6-font-size;
    color: $gray-2-color;
    font-weight: normal;
    text-align: center;
    margin-bottom: 0.625rem;
  }

  &__radio_buttons{
    column-gap: 30px;
    flex-wrap: wrap;
    row-gap: 15px;
  }
  .custom_radio_button{
    position: absolute;
    opacity: 0;
    pointer-events: none;
    box-sizing: border-box;
    padding: 0;
    + label{
      position: relative;
      font-size: 14px;
      color: $main-color;
      height: 24px;
      line-height: 24px;
      padding-left: 30px;
      &:before{
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        border: 1px solid $third-color;
        border-radius: 50%;
        margin: 2px;
        width: 20px;
        height: 20px;
        -webkit-transition: .28s ease;
        transition: .28s ease;
        z-index: 0;
      }
      &:after{
        border: 1px solid $third-color;
        margin: 2px;
        width: 20px;
        height: 20px;
        transform: scale(0);
        border-radius: 50%;
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        transition: .28s ease;
      }
    }
    &:checked{
      +label{
        &:after{
          transform: scale(0.7);
          background-color: $third-color;
          border: 2px solid $third-color;
        }
      }
    }
  }
}

.api_docs{

  --blue-1-color: #{$blue-1-color};
  --blue-2-color: #{$blue-2-color};
  --blue-3-color: #{$blue-3-color};
  --blue-4-color: #{$blue-4-color};
  --blue-5-color: #{$blue-5-color};
  --blue-6-color: #{$blue-6-color};

  flex-direction: column;
  align-items: center;
  margin-top: 1.875rem;
  &__title{
    font-size: $h6-font-size;
    color: $gray-2-color;
    font-weight: normal;
    text-align: center;
    margin-bottom: 0.625rem;
  }

  &__buttons{
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
    @include media-breakpoint-down(lg){
      display: grid!important;
      grid-template-columns: 1fr 1fr;
    }
    @include media-breakpoint-down(md){
      display: grid!important;
      grid-template-columns: 1fr;
    }
    .btn{
      padding: 0.625rem 1.25rem;
      font-family: $main-font;
      justify-content: center;
      @include media-breakpoint-down(md) {
        width: 225px;
      }
    }
    //@for $i from 1 through 5 {
    //  .btn:nth-child( #{$i}) {
    //    background-color: $blue-#{$i}-color;
    //  }
    //}
    @for $i from 1 through 6 {
      .btn:nth-child( #{$i}) {
        background-color: var(--blue-#{$i}-color);
        color: $blue-5-color;
      }
    }


  }

}





</style>